module.exports = __webpack_public_path__ + "img/linkedin.699cb925.svg";